import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { GRADUATION } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/graduation/new")({
  component: () => <DeptContentForm cfg={GRADUATION} />,
});
